<template>
  <div>
    <a-divider> {{ $t('Invoice funnels') }}</a-divider>
    <a-button
      type="primary"
      :disabled="editingKey !== ''"
      @click="handleAdd"
    >
      {{$t('Add')}}
    </a-button>
    <a-table
      :columns="columns"
      :data-source="data"
      bordered
      tableLayout="auto"
      :scroll="{ x: true }"
      :pagination="{ hideOnSinglePage: true }"
    >
      <template
        slot="sections"
        slot-scope="sections, record"
      >
        <a-select
          v-if="record.editable"
          mode="multiple"
          placeholder="Please select sections"
          :default-value="sections"
          option-filter-prop="children"
          style="width:100%"
          @change="e => handleChange(e, record.key, 'sections')"
        >
          <a-select-option
            v-for="(name, id) in SECTION_LIST"
            :key="id"
          >
            {{name}}
          </a-select-option>
        </a-select>
        <template v-else>
          <a-tag
            v-for="section in sections"
            :key="section"
            color="geekblue"
          >
            {{ SECTION_LIST[section] }}
          </a-tag>
        </template>
      </template>

      <template
        slot="users"
        slot-scope="users,record"
      >
        <a-select
          v-if="record.editable"
          mode="multiple"
          placeholder="Please select users"
          option-filter-prop="children"
          style="width:100%"
          :default-value="users"
          @change="e => handleChange(e, record.key, 'users')"
        >
          <a-select-option
            v-for="(name, id) in usernameList"
            :key="id"
          >{{
              name
            }}</a-select-option>
        </a-select>
        <template v-else>
          <a-tag
            v-for="user in users"
            :key="user"
            color="green"
          >
            {{ usernameList[user] }}
          </a-tag>
        </template>
      </template>
      <template
        slot="operation"
        slot-scope="text, record"
      >
        <div class="editable-row-operations">
          <span v-if="record.editable">
            <a-button
              type="link"
              icon="save"
              @click="() => save(record.key)"
            />
            <a-button
              type="link"
              icon="stop"
              @click="() => cancel(record.key)"
            />
          </span>
          <span v-else>
            <a-button
              :disabled="editingKey !== ''"
              type="link"
              icon="edit"
              @click="() => edit(record.key)"
            />
            <a-button
              :disabled="editingKey !== '' && !data.length"
              type="link"
              icon="delete"
              @click="() => onDelete(record.key)"
            />
          </span>
        </div>
      </template>
    </a-table>
  </div>
</template>
<script>
import { saveRightsToInvoiceFunnel } from "@/requestFunc";
export default {
  data() {
    return {
      columns: [
        {
          title: this.$t("Sections"),
          dataIndex: "sections",
          scopedSlots: { customRender: "sections" },
        },
        {
          title: this.$t("Users"),
          dataIndex: "users",
          scopedSlots: { customRender: "users" },
        },
        {
          title: this.$t("Op."),
          align: "center",
          width: 100,
          scopedSlots: { customRender: "operation" },
        },
      ],
      data: [],
      editingKey: "",
      lastKey: 0,
    };
  },
  props: ["usernameList", "SECTION_LIST", "rightsToInvoiceFunnel"],
  methods: {
    handleAdd() {
      const newData = {
        key: this.lastKey,
        sections: [],
        users: [],
        editable: true,
      };
      this.data.push(newData);
      this.editingKey = this.lastKey;
      this.lastKey++;
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(key) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = key;
      if (target) {
        target.editable = true;
        this.data = newData;
      }
    },
    save(key) {
      const newData = [...this.data];
      const newCacheData = [...this.cacheData];
      const target = newData.filter((item) => key === item.key)[0];
      const targetCache = newCacheData.filter((item) => key === item.key)[0];
      if (target && targetCache) {
        delete target.editable;
        this.data = newData;
        Object.assign(targetCache, target);
        this.cacheData = newCacheData;
      }
      this.editingKey = "";
      saveRightsToInvoiceFunnel(this.data);
    },
    cancel(key) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = "";
      if (target) {
        Object.assign(
          target,
          this.cacheData.filter((item) => key === item.key)[0]
        );
        delete target.editable;
        this.data = newData;
      }
    },
    onDelete(key) {
      const data = [...this.data];
      this.data = data.filter((item) => item.key !== key);
    },
  },
  mounted() {
    let i = 0;
    for (i in this.rightsToInvoiceFunnel) {
      this.data.push({
        key: i,
        sections: this.rightsToInvoiceFunnel[i].sections,
        users: this.rightsToInvoiceFunnel[i].users,
      });
    }
    this.lastKey = i;
    this.cacheData = this.data.map((item) => ({ ...item }));
  },
};
</script>